/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SalesFilterTemplateEventTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterTemplateEventFactory,
		FindAllSalesFilterTemplateEventsByQueryParamsFactory,
		NoPagingSalesFilterTemplateEventFactory,
		NoPagingSalesFilterFactory,
		NoPagingTemplateEventFactory
	) {
		$scope.salesFilterTemplateEventList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilterTemplateEvent)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilterTemplateEvent);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilterTemplateEvent = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newSalesFilterTemplateEvent', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(salesFilterTemplateEvent) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editSalesFilterTemplateEvent', {
				salesFilterTemplateEventId: salesFilterTemplateEvent.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getSalesFilterTemplateEventList = function() {
			FindAllSalesFilterTemplateEventsByQueryParamsFactory.query(
				{
					salesFilterId: angular.isDefined($scope.salesFilterId) ? $scope.salesFilterId : null,
					templateEventId: angular.isDefined($scope.templateEventId) ? $scope.templateEventId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterTemplateEventList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getSalesFilterTemplateEventList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
